<template>
    <div style="background-color: white" class="card-body">
        <el-row :gutter="30">
                <el-col :span="12" v-for="student in $parent.cell.students" :key="student.id">
                        <div :style="{'color':student.color}">
                            {{student.student_name}}
                        </div>
                </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ClassDetail",
        data() {
            return {
            }
        },
        created() {
        },
    }
</script>

<style scoped>

</style>